import { Box, Button, Typography } from "@material-ui/core";
import { X } from "phosphor-react";
import useEnterpriseThankYouModalStyles from "./EnterpriseThankYouModalStyles";

const EnterpriseThankYouModal = ({ handleClose }) => {
  const classes = useEnterpriseThankYouModalStyles();

  return (
    <Box className={classes.modalWrapper}>
      {/* Header */}
      <Box className={classes.header}>
        <Box className={classes.titleWrapper}>
          <Typography className={classes.title}>
            Thank you for submission
          </Typography>
        </Box>
        <Button onClick={handleClose}>
          <X size={22} color="#F9F9F9" />
        </Button>
      </Box>

      {/* Message */}
      <Box className={classes.messageWrapper}>
        <Typography className={classes.message}>
          Our cloud team will contact you in the next 24 hours to help setup the
          Enterprise Plan.
        </Typography>
      </Box>
    </Box>
  );
};

export default EnterpriseThankYouModal;
